//SETTING
export const AUTH_USER = "AUTH_USER";
export const GET_USER = "GET_USER";
export const FIND_USER = "FIND_USER";

export const GET_WORKSHIFT = "GET_WORKSHIFT";
export const FIND_WORKSHIFT = "FIND_WORKSHIFT";

export const GET_WORKLOCATION = "GET_WORKLOCATION";
export const FIND_WORKLOCATION = "FIND_WORKLOCATION";

export const GET_DEPARTMENT = "GET_DEPARTMENT";
export const FIND_DEPARTMENT = "FIND_DEPARTMENT";
export const GET_EMPLOYEES_DEPARTMENT_DROPDOWN = "GET_EMPLOYEES_DEPARTMENT_DROPDOWN";

export const GET_POSITION = "GET_POSITION";
export const FIND_POSITION = "FIND_POSITION";
export const GET_EMPLOYEES_POSITION_DROPDOWN = "GET_EMPLOYEES_POSITION_DROPDOWN";

export const GET_MODULE_TYPE = "GET_MODULE_TYPE";

export const GET_SYSTEM_ROLE = "GET_SYSTEM_ROLE";
export const FIND_SYSTEM_ROLE = "FIND_SYSTEM_ROLE";

export const GET_LEAVE_REQUEST = "GET_LEAVE_REQUEST";
export const FIND_LEAVE_REQUEST = "FIND_LEAVE_REQUEST";
export const GET_INFINITE_LEAVE_REQUEST = "GET_INFINITE_LEAVE_REQUEST";

export const GET_TOTAL_EMPLOYEE = "GET_TOTAL_EMPLOYEE";
export const GET_GENDER_DIVERSITY = "GET_GENDER_DIVERSITY";
export const GET_EMPLOYEE_ROLES = "GET_EMPLOYEE_ROLES";
export const GET_TOP_FIVE_EMPLOYEE = "GET_TOP_FIVE_EMPLOYEE";
export const GET_LEAVE_REQUEST_TODAY = "GET_LEAVE_REQUEST_TODAY";

export const GET_PAYROLL_REPORT = "GET_PAYROLL_REPORT";

export const GET_ATTENDANCE = "GET_ATTENDANCE";
export const GET_ATTENDANCE_REPORT = "GET_ATTENDANCE_REPORT";
export const GET_INFINITE_ATTENDANCE_REPORT = "GET_INFINITE_ATTENDANCE_REPORT";
export const FIND_ATTENDANCE = "FIND_ATTENDANCE";
export const GET_INFINITE_ATTENDANCE = "GET_INFINITE_ATTENDANCE";

export const FIND_ANNOUNCEMENT = "FIND_ANNOUNCEMENT";
export const GET_INFINITE_ANNOUNCEMENT = "GET_INFINITE_ANNOUNCEMENT";

export const GET_INFINITE_EMPLOYEES = "GET_INFINITE_EMPLOYEES";
export const FIND_EMPLOYEE = "FIND_EMPLOYEE";
export const FIND_EMPLOYEE_HISTORY = "FIND_EMPLOYEE_HISTORY";
export const GET_EMPLOYEES = "GET_EMPLOYEE";
export const GET_EMPLOYEE_STATUS = "GET_EMPLOYEE_STATUS";

// DROPDOWN
export const GET_EMPLOYEES_DROPDOWN = "GET_EMPLOYEES_DROPDOWN";
export const GET_DEPARTMENT_DROPDOWN = "GET_DEPARTMENT_DROPDOWN";
export const GET_POSITION_DROPDOWN = "GET_POSITION_DROPDOWN";
export const GET_SHIFT_DROPDOWN = "GET_SHIFT_DROPDOWN";
export const GET_LOCATION_DROPDOWN = "GET_LOCATION_DROPDOWN";
export const GET_COMPANY_DROPDOWN = "GET_COMPANY_DROPDOWN";
export const GET_LEAVE_TYPE_DROPDOWN = "GET_LEAVE_TYPE_DROPDOWN";
export const GET_SHIFTS_DROPDOWN = "GET_SHIFTS_DROPDOWN";
export const GET_DAYS_DROPDOWN = "GET_DAYS_DROPDOWN";
export const GET_USERS_DROPDOWN = "GET_USERS_DROPDOWN";
export const GET_ROLE_DROPDOWN = "GET_ROLE_DROPDOWN";
export const GET_WORK_LOCATION_DROPDOWN = "GET_WORK_LOCATION_DROPDOWN";
